"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var admin_complete_drive_html_1 = __importDefault(require("./admin-complete-drive.html"));
var admin_complete_drive_controller_1 = __importDefault(require("./admin-complete-drive.controller"));
function getDriveSession($stateParams, DrivesModel) {
    return DrivesModel.getDriveByID($stateParams.driveId).then(function (response) {
        return response.drive;
    });
}
getDriveSession.$inject = ["$stateParams", "DrivesModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.completedrive", {
        url: "/drive/:driveId/complete",
        controller: admin_complete_drive_controller_1.default,
        controllerAs: "vm",
        template: admin_complete_drive_html_1.default,
        resolve: {
            driveSession: getDriveSession,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.completedrive", [])
    .controller("AdminCompleteDriveController", admin_complete_drive_controller_1.default)
    .config(config);
